import { render } from "./StatoperateDetail.vue?vue&type=template&id=cb15f586&scoped=true"
import script from "./StatoperateDetail.vue?vue&type=script&lang=js"
export * from "./StatoperateDetail.vue?vue&type=script&lang=js"

import "./StatoperateDetail.vue?vue&type=style&index=0&id=cb15f586&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb15f586"]])

export default __exports__